/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Page action type literals. Coming in from skin API pageAction method call
 */
export enum SettingsDefault {

	/**
	 * @description Default volume
	 */
	VOLUME = 0.8,

	/**
	 * @description LTS Feature Tooltip max impressions per profile
	 */
	FEATURE_TOOLTIP_MAX_IMPRESSIONS = 5,

}